import { AjaxResponse } from 'rxjs/ajax';
import { ErrorReason } from '../../../../../env/constants/errors';

export type BuildClaimInfoLinkList = (response: AjaxResponse<ValidationResponse>) => ClaimInfoLink[];
export const buildClaimInfoLinkList: BuildClaimInfoLinkList = (response) => {
    const data: ValidationResponse = response.response;
    if (data.claims.length < 1) {
        throw new Error(ErrorReason.NO_CLAIMS);
    }
    const { inspections } = data.claims[0];

    if (inspections.length < 1) {
        throw new Error(ErrorReason.NO_INSPECTIONS);
    }

    return inspections.map((inspection: Inspection) => {
        return {
            link: inspection.link,
            make: inspection.claimInfo.make,
            model: inspection.claimInfo.model,
            year: inspection.claimInfo.year,
            streetAddress: inspection.claimInfo.streetAddress,
            city: inspection.claimInfo.city,
            state: inspection.claimInfo.state,
            zipcode: inspection.claimInfo.zipcode,
        };
    });
};
